import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from '@bingads-webui-react/primitive-validation';
import { TaxUtils, Constants } from '@bingads-webui-clientcenter/entity-utils';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { TaxOptionTypeKey, TaxOptionTypeI18nKey, TaxOptionTypesName } from '../constants';
import { useValidationI18n } from '../hooks/use-i18n';

const { TaxOptionType } = Constants;

const TaxOptionTypes = [TaxOptionType.Personal, TaxOptionType.Business];

export const TaxOptionTypeRenderer = ({
  i18n, taxOptionType, showLineByLineFormGroup, onTaxOptionTypeChange, disabled,
}) => {
  const validationI18n = useValidationI18n(i18n);
  const CustomizedFormGroup = showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;

  return (
    <CustomizedFormGroup isStatic id={TaxOptionTypeKey} label={i18n.getString(TaxOptionTypeI18nKey)}>
      <RadioGroup
        i18n={validationI18n}
        checked={taxOptionType}
        items={TaxOptionTypes}
        renderItem={taxOption => TaxUtils.getTaxOptionLabel(taxOption, i18n)}
        name={TaxOptionTypesName}
        onChange={onTaxOptionTypeChange}
        validationProps={{ i18n: validationI18n, required: true }}
        disabled={disabled}
      />
    </CustomizedFormGroup>
  );
};

TaxOptionTypeRenderer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  taxOptionType: PropTypes.string,
  showLineByLineFormGroup: PropTypes.bool,
  onTaxOptionTypeChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TaxOptionTypeRenderer.defaultProps = {
  taxOptionType: TaxOptionType.Business,
  showLineByLineFormGroup: false,
  disabled: false,
};
